import { combineReducers } from 'redux'
import AuthorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import recaptchaReducer from '../../containers/Recaptcha/Recaptcha.reducer'
import searchBuyerReducer from '../../containers/SearchBuyer/SearchBuyer.reducer'

export default combineReducers({
  authorizationProvider: AuthorizationProviderReducer,
  recaptcha: recaptchaReducer,
  searchBuyer: searchBuyerReducer
})
